import apiClient from './api';
import {
  ApiResponse,
  GpuConfigInstallLog,
  TaskWorkflowConfig,
  TaskWorkflowConfigPayload,
} from '../types';

const basePath = '/admin/task-workflow-configs';

export const taskWorkflowConfigApi = {
  list: (gpuType?: string): Promise<ApiResponse<TaskWorkflowConfig[]>> =>
    apiClient.get(basePath, { params: gpuType ? { gpuType } : undefined }),

  get: (id: number): Promise<ApiResponse<TaskWorkflowConfig>> =>
    apiClient.get(`${basePath}/${id}`),

  save: (
    payload: TaskWorkflowConfigPayload
  ): Promise<ApiResponse<TaskWorkflowConfig>> =>
    apiClient.post(basePath, payload),

  disable: (id: number): Promise<ApiResponse<string>> =>
    apiClient.delete(`${basePath}/${id}`),

  installLogs: (
    gpuId?: string,
    taskType?: number
  ): Promise<ApiResponse<GpuConfigInstallLog[]>> =>
    apiClient.get(`${basePath}/install-logs`, {
      params: {
        ...(gpuId ? { gpuId } : {}),
        ...(taskType != null ? { taskType } : {}),
      },
    }),
};
